import cookie from '@/common/utils/cookie'
import constant from '@/common/resources/constant'
import _ from 'lodash'
import { parseUrl } from 'query-string'
// referer 우선 순위
// 1. url
// 2. cookie
const REFERER_URL = 'referer-url'
const ENTER_URL = 'enter-url'

export const removeReferer = () => {
  cookie.removeItem(REFERER_URL, constant.URL_COOKIE_DOMAIN, '/')
}

export const setReferer = (url) => {
  removeReferer()
  cookie.setItem(REFERER_URL, url, null, constant.URL_COOKIE_DOMAIN, '/')
}

export const getReferer = () => {
  const cookieReferer = cookie.getItem(REFERER_URL)
  const { query } = parseUrl(location.href)
  const queryReferer = decodeURIComponent(_.get(query, 'referer', ''))
  return queryReferer === '' ? cookieReferer : queryReferer
}

export const removeEnterUrl = () => {
  cookie.removeItem(ENTER_URL, constant.URL_COOKIE_DOMAIN, '/')
}

export const setEnterUrl = (url) => {
  removeReferer()
  cookie.setItem(ENTER_URL, url, constant.URL_COOKIE_DOMAIN, null, '/')
}

export const getEnterUrl = () => {
  const cookieEnterUrl = cookie.getItem(ENTER_URL)
  const { query } = parseUrl(location.href)
  const queryEnterUrl = decodeURIComponent(_.get(query, 'enter', ''))
  return queryEnterUrl === '' ? cookieEnterUrl : queryEnterUrl
}
